import { Col, Collapse, Divider, Row } from 'antd';
import { TriggerComponent } from 'components/hitches/online-store/OrderCard';
import { useIntl } from 'react-intl';
import { ProductFromSale } from 'services/hitchit/types/usecases/OrderToDeal';

const { Panel } = Collapse;

type AnotherProductPickerProps = {
  onSetSelectedProductPreview: (preview: ProductFromSale) => void;
  selectedProductPreview?: ProductFromSale;
  previewProducts?: ProductFromSale[];
};

export const AnotherProductPicker = ({
  previewProducts,
  onSetSelectedProductPreview,
  selectedProductPreview,
}: AnotherProductPickerProps): JSX.Element => {
  const { formatMessage } = useIntl();

  return (
    <>
      <Divider orientation="left">
        <h3>
          {formatMessage({
            defaultMessage: 'Use another product variant as example',
            description: '/onboarding/preferences/anotherproduct/title',
          })}
        </h3>
      </Divider>
      <p>
        {formatMessage({
          defaultMessage: 'Is the preselected product an atypical one?',
          description: '/onboarding/preferences/anotherproduct/description/1',
        })}
      </p>
      <Collapse ghost>
        <Panel
          key="1"
          header={formatMessage({
            defaultMessage: 'Pick another one',
            description: '/onboarding/preferences/anothersale/button',
          })}
        >
          <p>
            {selectedProductPreview?.sale?.product?.isDummy
              ? formatMessage({
                  defaultMessage:
                    "We couldn't find an product in your shop just yet, therefore, we constructed a fake one to help you with your preferences.",
                })
              : formatMessage({
                  defaultMessage:
                    'We found out your products. We preselected one so you can imagine better what we will do once you configured this integration. If this is not a good example sale, pick another.',
                  description: '/onboarding/preferences/anotherproduct/description/long',
                })}
          </p>
          <Row justify="start">
            <Col span={24}>
              <Row justify="start" gutter={[32, 32]}>
                {previewProducts?.map((previewData: ProductFromSale) => (
                  <Col key={previewData.sale.product.id} sm={{ span: 24 }} lg={{ span: 12 }}>
                    {previewData.sale.product && (
                      <TriggerComponent
                        trigger={previewData.sale.product}
                        selected={
                          selectedProductPreview?.sale.product.id === previewData.sale.product.id
                        }
                        onChange={() => onSetSelectedProductPreview(previewData)}
                      />
                    )}
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
        </Panel>
      </Collapse>
    </>
  );
};
